import { useCallback, useEffect, useRef, useState } from "react";

type AutoTextareaProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxHeight?: number;
};

export function AutoTextarea({
  value,
  onChange,
  placeholder,
  maxHeight = 240,
}: AutoTextareaProps) {
  const ref = useRef<HTMLTextAreaElement | null>(null);
  const [overflowing, setOverflowing] = useState(false);

  const resize = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const natural = Math.max(72, el.scrollHeight);
    const capped = Math.min(natural, maxHeight);
    el.style.height = capped + "px";
    setOverflowing(natural > maxHeight);
  }, [maxHeight]);

  useEffect(() => {
    resize();
  }, [value, resize]);

  return (
    <textarea
      ref={ref}
      className="input"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onInput={resize}
      style={{
        resize: "none",
        overflowY: overflowing ? "auto" : "hidden",
        fontFamily: "inherit",
        fontSize: 13,
        lineHeight: 1.55,
        minHeight: 72,
        maxHeight,
      }}
    />
  );
}
